/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import i18n, { TFunction } from 'i18next';
import { initReactI18next } from 'react-i18next';
import initYupLocale from './initYupLocale';
import config from './config';

export const init = (): void => {
  i18n.use(initReactI18next).init(config, (_error, t: TFunction) => initYupLocale(t));
};
